import React from 'react';
import styled from 'styled-components';
import { Overlay } from 'react-bootstrap';
import dt, { useIsMobileOrTablet } from '../../../../../shared/theme';
import useFundsStateStore from '../../../common/funds-state-hook';
import {
  HintTooltip,
  Container,
  Title,
  Description,
  Button,
} from '../../../../shared/hint/styles';

const SHintTooltip = styled(HintTooltip)`
  ${props => dt(props).theme.isMobileOrTablet && `
    inset: 20px auto auto 0px !important;
  `};

  ${props => !dt(props).theme.isMobileOrTablet && `
    inset: -16px auto auto 20px !important;
  `};

  & > .arrow {
    ${props => !dt(props).theme.isMobileOrTablet && `
      top: -72px !important;
      left: -18px;
      border-top: 10px solid transparent;
      border-right: 20px solid ${dt(props).theme.bodyColor};
      border-bottom: 10px solid transparent;
    `};

    ${props => dt(props).theme.isMobileOrTablet && `
      top: -18px;
      left: -30px !important;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 20px solid ${dt(props).theme.bodyColor};
    `};
  }
`;

const Hint = React.forwardRef((_props, ref) => {
  const [show, setShow] = React.useState(false);
  const isMobileOrTablet = useIsMobileOrTablet();
  const set = useFundsStateStore(state => state.set);
  const assetClasses = useFundsStateStore(state => state.assetClasses);
  const showAssetClassFilterHint = useFundsStateStore(state => state.showAssetClassFilterHint);

  React.useEffect(() => {
    if (assetClasses.length > 0) {
      // delay to show the hint to make sure the filter is fully rendered
      setTimeout(() => setShow(true), 500);
    }
  }, [ref, assetClasses]);

  const handleClick = e => {
    e && e.preventDefault() && e.stopPropagation();
    e && e.target.closest('.show').classList.remove('show');

    if (showAssetClassFilterHint) {
      set(state => {
        state.showAssetClassFilterHint = false;
      });
    }
  };

  const placement = isMobileOrTablet ? 'bottom-start' : 'right-start';

  return (
    <Overlay target={ref.current} show={show} placement={placement}>
      {props => (
        <SHintTooltip className="ignore-onclickoutside" {...props}>
          <Container>
            <Title>
              Filter by Asset Class
              <span className="icon-lw icon-lw-info-circle" />
            </Title>
            <Description>
              Filter funds by selecting one or more asset classes, then clicking Apply.
            </Description>
            <Button onClick={handleClick}>Got it</Button>
          </Container>
        </SHintTooltip>
      )}
    </Overlay>
  );
});

export default Hint;
